<div id="tour-peer-selector" class="pro-options__target button" (click)="openModal()">
  <span class="pro-options__target-title">{{ peerName() }}</span>
  @if (type != PeerSelectorType.institution && displayPeer()?.group) {
  <div class="pro-widget__info pro-widget__info--target">
    <div class="pro-widget__info-window">{{ displayPeer()?.group?.displayDescription }}</div>
    <svg class="icon pro-widget__info-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z" /></svg>
  </div>
  @if (displayPeer()?.group?.groupType == 10 || displayPeer()?.group?.groupType == 20) {
  <span class="pro-options__target-count">{{ filteredGroupCount }} of {{ displayPeer()?.group?.institutionCount }}</span>
  <svg (click)="filter()" class="pro-options__target-icon icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z" /></svg>
  } @else {
  <span class="pro-options__target-count">{{ displayPeer()?.group?.institutionCount }}</span>
  }
  }
  <svg class="pro-options__target-icon icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z" /></svg>
</div>

@if (isOpen) {
<div class="modal modal--small target" [ngClass]="{ 'modal--fade-out': isClosing }">
  <div class="modal__screen" (click)="closeModal()"></div>
  <div class="modal__content">
    <div class="modal__header">
      <div class="modal__title">{{ isFilterOpen ? peerName() : 'Select Peer' }}</div>
      <div class="modal__close" (click)="closeModal()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon modal__close-icon"><path d="M232 344V280H168C154.7 280 144 269.3 144 256C144 242.7 154.7 232 168 232H232V168C232 154.7 242.7 144 256 144C269.3 144 280 154.7 280 168V232H344C357.3 232 368 242.7 368 256C368 269.3 357.3 280 344 280H280V344C280 357.3 269.3 368 256 368C242.7 368 232 357.3 232 344zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"></path></svg>
      </div>
    </div>
    <div class="modal__body">
      <div class="pro-list pro-list--open">
        <div class="pro-list__inner">
          @if (type == PeerSelectorType.all || type == PeerSelectorType.institution) {
          <div class="pro-list__search">
            <svg class="icon pro-list__search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z" /></svg>
            <app-institution-autocomplete #institutionAutocomplete
                                          placeholder="Search for individual banks"
                                          class="pro-list__search-input"
                                          [onlyActive]="true"
                                          [excludedIids]="[institution().iid]"
                                          [institutionType]="institution().institutionType"
                                          (selectInstitutionEvent)="selectInstitution($event)">
            </app-institution-autocomplete>
          </div>
          }
          @if (type == PeerSelectorType.institution) {
          <ul class="institution-list">
            <li class="institution-list-heading pro-list__options-item--open">
              <div class="pro-list__options-item pro-list__options-title">Selected Institutions</div>
              <ul class="pro-list__options-sub">
                @for (institution of peerInstitutions(); track institution.iid) {
                <li class="pro-list__options-sub-item pro-list__options-sub-item--filter">
                  <span class="pro-list__options-sub-item-select">{{ institution.name }}</span>
                  <span class="pro-list__options-sub-item-filter" (click)="removeInstitution(institution)">Remove</span>
                </li>
                }
              </ul>
            </li>
          </ul>
          }
          @else {
          <ul class="pro-list__options">
            @if (customGroups.length > 0) {
            <li class="pro-list__options-item" [ngClass]="{ 'pro-list__options-item--open': isCategoryOpen('custom') }">
              <div class="pro-list__options-title" (click)="toggleCategory('custom')">My Peer Groups <svg class="icon pro-list__options-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z" /></svg></div>
              <ul class="pro-list__options-sub">
                @for (group of customGroups; track group.groupId) {
                <li class="pro-list__options-sub-item pro-list__options-sub-item--filter">
                  <span class="pro-list__options-sub-item-select" (click)="selectGroup(group.groupId)">{{ group.name }}</span>
                  <span class="pro-list__options-sub-item-filter" (click)="filterGroup()">Filter Group</span>
                </li>
                }
              </ul>
            </li>
            }
            @if (vbcGroups.length > 0) {
            <li class="pro-list__options-item" [ngClass]="{ 'pro-list__options-item--open': isCategoryOpen('vbc') }">
              <div class="pro-list__options-title" (click)="toggleCategory('vbc')">VBC Peer Groups <svg class="icon pro-list__options-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z" /></svg></div>
              <ul class="pro-list__options-sub">
                @for (group of vbcGroups; track group.groupId) {
                <li class="pro-list__options-sub-item pro-list__options-sub-item--filter">
                  <span class="pro-list__options-sub-item-select" (click)="selectGroup(group.groupId)">{{ group.name }}</span>
                  <span class="pro-list__options-sub-item-filter" (click)="filterGroup()">Filter Group</span>
                </li>
                }
              </ul>
            </li>
            }
            @if (aggregateGroups.length > 0) {
            <li class="pro-list__options-item" [ngClass]="{ 'pro-list__options-item--open': isCategoryOpen('aggregate') }">
              <div class="pro-list__options-title" (click)="toggleCategory('aggregate')">Aggregate Peer Groups <svg class="icon pro-list__options-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z" /></svg></div>
              <ul class="pro-list__options-sub">
                @for (group of aggregateGroups; track group.groupId) {
                <li class="pro-list__options-sub-item" (click)="selectGroup(group.groupId)">{{ group.name }}</li>
                }
              </ul>
            </li>
            }
          </ul>
          }
        </div>
      </div>
      <div class="target-filter" [ngClass]="{ 'target-filter--open': isFilterOpen }">
        <div class="checks checks--filter">
          <div class="checks__option">
            <input class="checks__input" type="checkbox" id="all" [(ngModel)]="isMasterChecked" [ngModelOptions]="{standalone: true}" (change)="selectMaster()" value='true' />
            <label class="checks__label" for="all"></label>
            <div class="checks__text">Select All</div>
          </div>
          @for (institution of group()?.institutions; track institution.iid) {
          <div class="checks__option">
            <input class="checks__input" type="checkbox" [id]="institution.iid" [(ngModel)]="institution.isSelected" [ngModelOptions]="{standalone: true}" (change)="filterInstitution()" />
            <label class="checks__label" [for]="institution.iid"></label>
            <div class="checks__text">
              {{ institution.label }}
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}
